function clean(obj: any) {
  for (const propName in obj) {
    if (
      !obj[propName] ||
      (Array.isArray(obj[propName]) && obj[propName].length === 0)
    ) {
      delete obj[propName];
    }
  }
  return obj;
}

export default clean;
